"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDayFilterDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const shared_1 = require("../shared");
const array_1 = require("../../util/array");
class CalendarDayFilterDto extends shared_1.PaginationOptionsDto {
    constructor(calendarDayFilterOptions) {
        super();
        if (!calendarDayFilterOptions)
            return;
        this.startDate = calendarDayFilterOptions.startDate;
        this.endDate = calendarDayFilterOptions.endDate;
        this.schoolId = calendarDayFilterOptions.schoolId;
        this.name = calendarDayFilterOptions.name;
        this.notes = calendarDayFilterOptions.notes;
        this.bellScheduleIds = calendarDayFilterOptions.bellScheduleIds;
        this.reactionIds = calendarDayFilterOptions.reactionIds;
        this.heroEventIds = calendarDayFilterOptions.heroEventIds;
    }
    startDate;
    endDate;
    schoolId;
    bellScheduleIds;
    reactionIds;
    heroEventIds;
    name;
    notes;
}
exports.CalendarDayFilterDto = CalendarDayFilterDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Number)
], CalendarDayFilterDto.prototype, "startDate", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Number)
], CalendarDayFilterDto.prototype, "endDate", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], CalendarDayFilterDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsPositive)({ each: true }),
    (0, class_validator_1.IsArray)(),
    (0, array_1.TryArray)(),
    (0, class_transformer_1.Transform)(({ value }) => value.map(Number)),
    __metadata("design:type", Array)
], CalendarDayFilterDto.prototype, "bellScheduleIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsPositive)({ each: true }),
    (0, class_validator_1.IsArray)(),
    (0, array_1.TryArray)(),
    (0, class_transformer_1.Transform)(({ value }) => value.map(Number)),
    __metadata("design:type", Array)
], CalendarDayFilterDto.prototype, "reactionIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsPositive)({ each: true }),
    (0, class_validator_1.IsArray)(),
    (0, array_1.TryArray)(),
    (0, class_transformer_1.Transform)(({ value }) => value.map(Number)),
    __metadata("design:type", Array)
], CalendarDayFilterDto.prototype, "heroEventIds", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(50),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CalendarDayFilterDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(250),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CalendarDayFilterDto.prototype, "notes", void 0);
